<select [formControl]="selectControl" [id]="id" [class]="classes" (keyup)="handleDeletePress($event)" [attr.disabled]="disabled || isDisabled ? true : null">
    <option *ngIf="placeholderMsg" [ngValue]="null" hidden disabled class="sh-select__placeholder">{{ placeholderMsg }}</option>
    <option *ngIf="showEmptyOption" [ngValue]="null">{{ emptyOptionLabel }}</option>
    <option *ngIf="extraOption" value="{{ extraOption?.value }}" disabled>{{ extraOption?.label }}</option>
    @for (option of options; track option) {
        <option value="{{ option.value }}" [attr.disabled]="disabled || isDisabled || option.disabled ? true : null" [title]="option.disabledInfoMsg">{{ option.label }}</option>
    }
</select>
